<!-- 促销头 -->
<template>
  <div :class="{ 'h5-promotion-wrap': isH5, 'promotion-wrap': !isH5 }">
    <div class="info-wrap">
      <div class="left">
        <p class="price">
          <span>￥</span>{{ promotionInfo.promotion_price / 100 }}
        </p>
        <p class="original-price">
          原价<span class="num">￥{{ originalPrice / 100 }}</span>
        </p>
        <img
          class="separate"
          src="../../../assets/images/product-details/group-info-separate.png"
          alt=""
        />
      </div>
      <GroupCountDown
        class="promotion-countdown"
        :endTime="promotionInfo.end_time"
        :type="2"
        :callback="callback"
        :intervalTime="1000"
        :activityType="2"
      />
    </div>
  </div>
</template>

<script>
import { isH5 } from "@saas/components/src";
import { GroupCountDown } from "@saas/components/src";
export default {
  props: {
    promotionInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    originalPrice: {
      type: Number,
      default: 0,
    },
  },

  data: function () {
    return {
      isH5: isH5(),
    };
  },
  methods: {
    callback() {
      // 刷新页面
      window.location.reload();
    },
  },
  components: {
    GroupCountDown,
  },
};
</script>

<style lang="scss" scoped>
.promotion-wrap {
  .info-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 354px;
    height: 56px;
    background: url("../../../assets/images/product-details/group-info-bg.png");
    background-size: auto 51px;
    background-position: center center;
    background-repeat: no-repeat;
    margin-bottom: 4px;
    .left {
      position: relative;
      padding-left: 10px;
      height: 100%;
      display: flex;
      flex: 1;
      align-items: center;
      .price {
        margin-right: 6px;
        color: #ffffff;
        font-weight: 600;
        span {
          font-size: 12px;
          line-height: 17px;
        }
        font-size: 24px;
        line-height: 33px;
      }
      .original-price {
        .num {
          text-decoration: line-through;
        }
        display: flex;
        align-items: center;
        height: 24px;
        font-weight: 500;
        font-size: 12px;
        color: #ffffff;
        line-height: 16px;
        border-radius: 8px;
        padding: 0 6px;
        border: 1px solid rgba($color: #ffffff, $alpha: 0.3);
      }
    }
    .separate {
      position: absolute;
      top: 0;
      right: -40px;
      width: 44px;
      height: 56px;
    }
  }
  .promotion-countdown {
    padding-left: 45px;
    padding-right: 10px;
    min-width: 140px;
    height: 100%;
    background: url("../../../assets/images/product-details/group-info-bg2.png");
    background-size: 100% 53px;
    background-position: center center;
    background-repeat: no-repeat;
  }
}

.h5-promotion-wrap {
  margin: 0 auto 0.35rem;
  .info-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 9.36rem;
    height: 1.48rem;
    background: url("../../../assets/images/product-details/group-info-bg.png");
    background-size: auto 1.32rem;
    background-position: center center;
    background-repeat: no-repeat;
    .left {
      position: relative;
      padding-left: 0.27rem;
      height: 100%;
      display: flex;
      flex: 1;
      align-items: center;
      .price {
        margin-right: 0.23rem;
        color: #ffffff;
        font-weight: 600;
        span {
          font-size: 0.32rem;
          line-height: 0.44rem;
        }
        font-size: 0.61rem;
        line-height: 1.48rem;
      }
      .original-price {
        .num {
          text-decoration: line-through;
        }
        display: flex;
        align-items: center;
        height: 0.63rem;
        font-weight: 500;
        font-size: 0.32rem;
        color: #ffffff;
        line-height: 0.42rem;
        border-radius: 0.21rem;
        padding: 0 0.16rem;
        border: 0.03rem solid rgba($color: #ffffff, $alpha: 0.3);
      }
    }
    .separate {
      position: absolute;
      top: 0;
      right: -40px;
      width: 1.14rem;
      height: 1.48rem;
    }
    .promotion-countdown {
      padding-left: 1.14rem;
      padding-right: 0.4rem;
      min-width: 3.73rem;
      height: 100%;
      background: url("../../../assets/images/product-details/group-info-bg2.png");
      background-size: 100% 1.35rem;
      background-position: center center;
      background-repeat: no-repeat;
    }
  }
}
</style>
